<template>
  <div class="sim">
    <h2>NPB{{this.PageDetail.title}} 類似性スコア検索
      <img v-if="PBcheck==='b'" class="img" src="../assets/batter.png" height="64" />
      <img v-if="PBcheck==='p'" class="img" src="../assets/pitcher.png" height="64" />
    </h2>
    <ul>
      <nameinput></nameinput>
      <div class="form-row col-md-20">
        <div class="col-md-3 form-row form-group form-inline">
          <button class="btn btn-primary" @click="seachPlayers();">類似選手検索</button>
        </div>
      </div>
      <seachresult></seachresult>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
import nameinput from './SimilarityParts/NameInput.vue'
import seachresult from './SimilarityParts/SeachResult.vue'
import Mixin from '../mixins/utility'
import usersbt from '../assets/player_record_batter_total2.json'
import userspt from '../assets/player_record_pitcher_total2.json'
import usersby from '../assets/player_record_batter_year2.json'
import userspy from '../assets/player_record_pitcher_year2.json'

export default {
  name: 'Similarity',
  mixins: [Mixin],
  data () {
    return {
      dataDetail: []
    }
  },
  beforeRouteUpdate (to, form, next) {
    this.PageLoads(to.params.id).then(function () {
      next()
    })
  },
  created: function () {
    this.PageLoads(this.$route.params.id)
  },
  computed: {
    PageDetail () {
      const detail = this.$store.state.list.find(l => l.id.toString() === this.$route.params.id.toString())
      return (detail === undefined ? this.$store.state.blank : detail)
    },
    simPostemp () {
      return {
        '捕': 1,
        '遊': 3,
        '二': 3,
        '三': 3,
        '外': 4,
        '一': 2,
        '指': 0,
        '投': 0
      }
    }
  },
  methods: {
    async PageLoads (pid) {
      await this.onLoad(pid)
    },
    async onLoad (pid) {
      if (this.$store.state.list.find(l => l.id.toString() === pid) === undefined) {
        document.location = '/'
        return
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('setValue', {vals: '', keyname: 'playername'})
      let record = {}
      Object.keys(this.record).some((p) => {
        record[p] = ''
      })
      this.$store.dispatch('setValue', {vals: record, keyname: 'record'})
      this.$store.dispatch('setValue', {vals: [], keyname: 'result_players'})
      this.$store.dispatch('setValue', {vals: [false, false, false, false, false, false, false, false], keyname: 'selectedPoss'})
      this.message = await this.LoadData(pid)
      this.$store.dispatch('setValue', {vals: 'N', keyname: 'Tabselect'})

      this.$store.commit('setLoading', false)
    },
    ZeroForm () {
      let record = this.record
      let recordlist = this.InputRecordList
      recordlist.push([this.InputProfile])
      recordlist.some(r => {
        if (isNaN(this.record[r]) === true || this.record[r] === '') record[r] = 0
        record[r] = Number(this.record[r])
      })
      this.$store.dispatch('setValue', {vals: record, keyname: 'record'})
    },
    seachPlayers () {
      this.ZeroForm()
      let result = []
      if (this.Tabselect === 'N') {
        if (this.PBcheck === 'b') {
          result = this.seachPlayersB(this.record)
        } else {
          result = this.seachPlayersP(this.record)
        }
      } else {
        let playerrecord = Object.create(this.record)
        playerrecord.hand = this.$store.state.record['hand']
        if (playerrecord.hand === null)playerrecord.hand = ''
        let rlist = {}
        if (this.PBcheck === 'b') {
          rlist = {
            expr: { age: 20, hand: 75 },
            prod: { Kpa: 450, Bpa: 750, HRpa: 850, HBPpa: 75, SBGO: 1.5, ISOP: 450, AVG: 450, SECpa: 150 },
            appo: { G: 0.45, PA: 0.35 },
            poss: { poss: 1 }
          }
        } else {
          rlist = {
            expr: { age: 20, hand: 90 },
            prod: { Kpa: 900, Bpa: 950, HRpa: 450, HBPpa: 150, ERA: 32.5, FIP: 20 },
            appo: { G: 0.5, IP: 0.65, GS: 0.4, GSpa: 40 }
          }
        }
        if (this.Tabselect === 'P') {
          const pldata = this.nameSlice(this.$store.state.playername)
          const idcheck = this.users.filter(p => p.r_name === pldata.name && Number(p.nen) === Number(pldata.year))
          if (idcheck.length === 0) return
          const playerID = idcheck[0].id
          const fil = this.users.filter(p => p.id === playerID) // まず選手IDで抽出
          let player = []
          for (let i = 0; i < 3; i++) {
            const ps = fil.filter(p => Number(p.nen) === (Number(pldata.year) - i))
            if (ps.length !== 0) player.push(ps[0]); else player.push(this.InputEmptyPlayer(fil[0], i))
          }
          result = this.seachPlayersSim(player, rlist)
        } else {
          result = this.seachPlayersPSP(playerrecord, rlist)
        }
      }
      this.$store.dispatch('setValue', {vals: result, keyname: 'result_players'})
    },
    InputEmptyPlayer (data, nen) {
      let obj = Object.assign({}, data)
      Object.keys(data).some(function (r, index) {
        if (r === 'r_name') return true
        else obj[r] = 0
      })
      obj.age = obj.age - nen
      return obj
    },
    SimPos (pr, pdef) {
      let score = 0
      const prdef = this.posSet(pr.DEF)

      const coef = {
        '捕': 150,
        '遊': 102,
        '二': 90,
        '三': 64,
        '外': 36,
        '一': 8
      }
      const sumpd = this.arrsum(Object.values(pdef))
      const sumprd = this.arrsum(Object.values(prdef))
      const cw = this.calcWari
      Object.keys(coef).some(function (pos) {
        score += Math.abs(
          cw(pdef[pos], sumpd) - cw(prdef[pos], sumprd)
        ) * coef[pos]
      })
      if (score > 1000) score = 1000
      return score
    },
    SimType (rlist, r, pr) {
      const cr = this.calcRecord
      let score = 0
      const pb = this.PBcheck
      Object.keys(rlist).some(function (rec) {
        let para = [cr(rec, r), cr(rec, pr)]
        const minpara = (rec === 'G' ? 130 : rec === 'age' ? 40 : 9999)
        if (rec === 'hand') {
          for (let p = 0; p < para.length; p++) {
            para[p] = parseInt(pb === 'p' ? para[p] / 3 : para[p] % 3)
            if (para[p] === 2) para[p] = 0.6
          }
        }
        for (let p = 0; p < para.length; p++) {
          para[p] = Math.min(para[p], minpara)
          if (rec === 'age')para[p] = Math.max(para[p], 18)
        }
        const sa = Math.abs(para[0] - para[1])
        score += Math.min(sa * rlist[rec], 200)
        if (rec === 'age' && sa > 5) {
          score += 1000
          return true
        }
      })
      if (score > 1000) score = 1000
      return score
    },
    calcScore (s, hosei) {
      return Math.pow((1000 - s * hosei) / 1000, 2)
    },
    calcScores (l, up, pl, pdef, hosei) {
      return this.calcScore('poss' in l
        ? this.SimPos(up, pdef) : this.SimType(l, up, pl),
      hosei)
    },
    seachPlayersPSP (playerrecord, rlist) {
      let hosei = 1.0
      // const hosei = (Object.keys(rlist).length === 3 ? 1 : 1)
      const ip = this.InputProfile
      Object.keys(rlist['expr']).forEach(function (rec) {
        if (ip.indexOf(rec) === -1) rlist['expr'][rec] = 0
      })
      let pdef
      if ('poss' in rlist) {
        pdef = this.inputedPoss
        this.PosList.some(pos => {
          if (isNaN(pdef[pos]) === true || pdef[pos] === '')pdef[pos] = 0
          pdef[pos] = Number(pdef[pos])
        })
        this.$store.dispatch('setValue', {vals: pdef, keyname: 'inputedPoss'})
      }
      const yc = (this.Yearcheck === 't')
      let scores = {}
      const css = this.calcScores
      this.users.forEach(function (p, pindex) {
        let score = 1000
        Object.values(rlist).some(function (l) {
          if (yc && ('G' in l))hosei = 0.4
          else hosei = 1.0
          score = css(l, p, playerrecord, pdef, hosei) * score
          if (score <= 0) return true
        })
        score = Math.round(score * 10) / 10
        scores[pindex] = score
      })
      return this.ScoreSort(scores)
    },
    seachPlayersP (record) {
      const rpoint = {
        G: 10,
        W: 1,
        L: 2,
        WR: 0.002,
        ERA: 0.02,
        GS: 20,
        CG: 20,
        IPa: 50,
        IPb: 50 / 3,
        H: 50,
        SO: 30,
        BB: 10,
        ShO: 5
      }
      let scores = {}
      let playerrecord = record
      playerrecord.WR = this.setWR(playerrecord.W, playerrecord.L)
      playerrecord.ERA = this.setERA
      this.users.forEach((p, pindex) => {
        var score = 1000
        Object.keys(rpoint).forEach(key => {
          var rec = key
          if (rec === 'WR')p[rec] = this.setWR(p.W, p.L)
          var temp = Math.abs(p[rec] - playerrecord[rec]) / rpoint[rec]
          if (rec === 'ERA' || rec === 'WR')temp = Math.min(temp, 100)
          score -= temp
        })
        score = Math.round(score * 10) / 10
        scores[pindex] = score
      })
      return this.ScoreSort(scores)
    },
    seachPlayersB (record) {
      const rpoint = {
        G: 20,
        AB: 75,
        R: 10,
        H: 15,
        SEC: 5,
        THI: 4,
        HR: 2,
        RBI: 10,
        BB: 25,
        SO: 150,
        SB: 20,
        AVG: 0.001,
        SLG: 0.002
      }
      const posCoef = {
        '捕': 240,
        '遊': 168,
        '二': 132,
        '三': 84,
        '外': 48,
        '一': 12,
        '指': 0,
        '投': 0
      }
      const rlist = Object.keys(rpoint)
      let playerrecord = record
      playerrecord.SLG = Math.round((playerrecord.H + playerrecord.SEC * 1 + playerrecord.THI * 2 + playerrecord.HR * 3) / playerrecord.AB * 1000) / 1000
      playerrecord.AVG = this.setAVG
      let scores = {}
      this.users.forEach((p, pindex) => {
        var score = 1000
        rlist.forEach(r => {
          var rec = (r === 'OPS' ? 'SLG' : r)
          score -= Math.abs(p[rec] - playerrecord[rec]) / rpoint[rec]
        })
        if (this.targetPos) {
          this.PosList.some((pos, index) => {
            score -= Math.abs((p.DEF.indexOf(pos) > -1) - Number(this.selectedPoss[index])) * posCoef[pos]
          })
        }
        score = Math.round(score * 10) / 10
        scores[pindex] = score
      })
      return this.ScoreSort(scores)
    },
    ScoreSort (scores) {
      var temprp = []
      const outname = (this.targetMatchName ? this.nameSlice(this.$store.state.playername).name : '')

      this.users.forEach((p, pindex) => {
        const score = scores[pindex]
        if (this.users[pindex].r_name !== outname && score > 0 && (temprp.length < this.resultmax || temprp[this.resultmax - 1].score < score)) {
          if (temprp.length === 0 || temprp[0].score < score) {
            temprp.unshift({num: pindex, score: score})
          } else {
            for (var i = temprp.length - 1; i >= 0; i--) {
              if (temprp[i].score >= score) {
                temprp.splice(i + 1, 0, {num: pindex, score: score})
                return true
              }
            }
          }
        }
        if (temprp.length > this.resultmax) {
          temprp = temprp.slice(0, -1)
        }
      })
      return temprp
    },
    getJson (rec, nen) {
      return new Promise(function (resolve, reject) {
        var hostName = document.location.hostname
        let url = ''
        if (hostName === 'localhost' || hostName === '127.0.0.1') {
          url = 'http://localhost:8000/html/record_dev.php' + '?rec=' + rec + '&nen=' + nen
        } else {
          url = 'http://similarity.pennantj.xyz/json/' + 'player_record_' + (rec === 'p' ? 'pitcher' : 'batter') + '_' + nen + '.json'
        }
        axios.get(url).then(function (res) {
          resolve(res.data.param)
        })
      })
    },
    setUsers (rec, nen) {
      let temps = []
      const userdata = (rec === 'p' ? (nen === 'year' ? userspy : userspt) : (nen === 'year' ? usersby : usersbt))
      console.log(userdata)
      const rl = this.RecList
      userdata.some(function (player) {
        let obj = {}
        rl[rec].some(function (r, index) {
          obj[r] = player[index]
        })
        temps.push(obj)
      })
      return temps
    },

    async LoadData (pid) {
      let rec = pid[0]
      let nen = pid.slice(1)
      this.$store.dispatch('setValue', {vals: this.setUsers(rec, nen), keyname: 'users'})
      // this.$store.dispatch('setValue', {vals: await this.getJson(rec, nen), keyname: 'users'})
      var list = []
      const yflag = (nen[0] === 'y')
      this.users.forEach(function (p, index) {
        let name = p.r_name
        if (yflag) name += '/' + p.nen
        if (list.indexOf(name) <= -1) list.push(name)
      })
      console.log(this.users)
      this.$store.dispatch('setValue', {vals: list, keyname: 'suggestionList'})
      return true
    }
  },
  mounted () {
  },
  components: {
    nameinput,
    seachresult
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Similarity.vue